// Функция для прокрутки до секции с использованием requestAnimationFrame
export const scrollToSection = (id) => {
  const element = document.getElementById(id);

  // Проверяем, что элемент найден
  if (element) {
    // Функция, которая прокручивает страницу плавно
    const scroll = () => {
      window.scrollTo({
        top: element.offsetTop,
        behavior: "smooth",
      });
    };

    // Используем requestAnimationFrame, чтобы прокрутка произошла после отрисовки
    if (document.readyState === 'complete') {
      // Если страница уже загружена, сразу прокручиваем
      requestAnimationFrame(scroll);
    } else {
      // Если страница ещё не загружена, ждём её готовности
      window.addEventListener('load', () => {
        requestAnimationFrame(scroll);
      });
    }
  }
};
